// Fonte única de queryKeys para React Query.
// Hoje o projeto usa React Query apenas em useSupplierContext + TabSyncBridge.
// Manter aqui evita drift entre useQuery(...) e invalidateQueries(...).
//
// Não criamos `createQuery` ou factory de hooks: queryKeys são dados puros
// (arrays imutáveis), os hooks que usam continuam explícitos.

export const qk = {
  wallet: () => ["wallet"] as const,
  walletTx: () => ["wallet-tx"] as const,
  orders: () => ["orders"] as const,
  myOrders: () => ["my-orders"] as const,
  supplierContext: (userId: string | undefined) => ["supplier-context", userId] as const,
} as const;

// staleTime sugerido por categoria (em ms). Documentação — não é enforced.
//   wallet/walletTx  → 30s  (saldo muda com cada compra/recarga)
//   orders           → 30s  (status atualiza via realtime)
//   supplierContext  → 60s  (kyc/wallet mudam raramente em uma sessão)
export const qkStale = {
  wallet: 30_000,
  orders: 30_000,
  supplierContext: 60_000,
} as const;
